import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { apiRequest } from "../Auth/AuthConfig.tsx";
import React, { ReactNode, useEffect, useRef } from "react";
import { useMsal } from "@azure/msal-react";
import { getRoles } from "../Services/AuthenticationService.tsx";
import { useUserContext } from "../Context/UserContext.tsx";
import { useNavigate, useLocation } from "react-router-dom";
import useAccessToken from "../Custom/useAccessToken.tsx";
import SessionService from "../Services/SessionService.tsx";

interface AuthenticatedRouteProps {
  children: ReactNode;
}

const AuthenticatedRoute: React.FC<AuthenticatedRouteProps> = ({
  children,
}) => {
  const { setUserInfo } = useUserContext();
  const { accessToken } = useAccessToken();
  //const { instance, accounts } = useMsal();
  const navigate = useNavigate();
  const location = useLocation();

  const hasFetched = useRef(false);

  useEffect(() => {
    if (!accessToken) return;
    const fetchUserInfo = async () => {
      if (!accessToken || hasFetched.current) return;

      try {
        hasFetched.current = true;

        const apiResponse = await getRoles(accessToken, "");
        const userData = apiResponse[0];

        const name = userData.shareholderName || "Unknown User";
        const isGrowthTeam = userData.isGrowthTeam === true || userData.isGrowthTeam === "true";
        const isGrowthLeader = userData.isGrowthLeader === true || userData.isGrowthLeader === "true";
        const hasShareholderAccess = userData.hasShareholderAccess === true || userData.hasShareholderAccess === "true";
        const isGrowthOnly = userData.roleName?.toLowerCase() === "growth team";
        // const role =
        //   userData.isLeader?.toString() === "true" ? "Leader" : "Shareholder";
        let role = "Shareholder";

        if (isGrowthLeader) {
          role = "Leader";
        } else if (userData.isLeader?.toString() === "true" && userData.isCOLeader?.toString() === "true") {
          role = "Leader";
        }
        else if (userData.isCOLeader?.toString() === "true") {
          role = "CoLeader";
        } else if (userData.isLeader?.toString() === "true") {
          role = "Leader";
        }
         
        const serviceLine = userData.serviceLine || "Unknown Service Line";
        const userId = userData.shareholderId || "Unknown User ID";
        const roleName = userData.roleName || "Unknown Role";
        const isAdmin = Boolean(userData.isAdmin);
        const leaderId = userData.leaderId;
        const leaderName = userData.leaderName;
        const leaderEntraId =
          userData.leaderEntraId || "Unknown Leader Entra ID";
        const shareholderEntraID =
          userData.shareholderEntraID || "Unknown Leader Entra ID";

        setUserInfo({
          username: name,
          role: role,
          userId: userId,
          serviceLine: serviceLine,
          rolename: roleName,
          isAdmin: isAdmin,
          hasShareholderAccess: hasShareholderAccess,
          isGrowthTeam: isGrowthTeam,
          isGrowthLeader: isGrowthLeader,
          leaderId: leaderId,
          leaderName: leaderName,
          leaderEntraId: leaderEntraId,
          shareholderEntraID: shareholderEntraID,
        });

        SessionService.setRole(roleName);

        if (isGrowthTeam && !isGrowthLeader && isGrowthOnly && location.pathname === "/") {
          SessionService.setNavigateTo("GrowthLandingPage");
          navigate("/growth", { replace: true });
        } else if (role === "Shareholder" && location.pathname === "/") {
          SessionService.setSHId(userId);
          SessionService.setNavigateTo("EvaluationPlan");
          navigate("/evaluationPlan", { replace: true });
        } else {
          SessionService.setNavigateTo(
            location.pathname?.includes("/evaluationPlan")
              ? "EvaluationPlan"
              : "LeaderLandingPage"
          );

          navigate(location.pathname, { replace: true });
        }
      } catch (err) {
        console.error("Error fetching user info", err);
        // Optionally redirect to unauthorized
        // navigate("/unauthorized", { replace: true });
      }
    };

    fetchUserInfo();
  }, [accessToken, setUserInfo, navigate]);

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={apiRequest}
    >
      {children}
    </MsalAuthenticationTemplate>
  );
};

export default AuthenticatedRoute;
